<script setup>
import { SwButton } from '@getswish/design-library-web';
import ModalLayout from '@/_company/components/ModalLayout.vue';

defineProps({
  title: {
    type: String,
  },

  text: {
    type: String,
  },
});

const emit = defineEmits(['onConfirm']);
</script>

<template>
  <ModalLayout @onClose="emit('onConfirm')">
    <template v-slot:header>
      <h2>{{ title }}</h2>
    </template>

    <template v-slot:body>
      <p>{{ text }}</p>
    </template>

    <template v-slot:footer>
      <SwButton label="Ok" @click="emit('onConfirm')" />
    </template>
  </ModalLayout>
</template>
